module.exports = __webpack_public_path__ + "img/album05_02.a7000264.jpg";